module.exports = __webpack_public_path__ + "static/media/image.4f356006.jpg";